import connectQueryRules from '../connectors/connectQueryRules';
export default connectQueryRules(function QueryRuleContext() {
  return null;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-core/dist/es/widgets/QueryRuleContext.js
// module id = 108
// module chunks = 0